// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_home__1jket {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh);
}
.home_inner__iVYU5 {
  max-width: 500px;
  padding: 30px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.home_rule__cd9Jo {
  min-height: 32px;
  margin-bottom: -56px;
  z-index: 100;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  width: 100%;
}
.home_ruleInner__RBuaG {
}
.home_hero__9-mJf {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 144px;
}
.home_hero__9-mJf img {
  width: 100%;
}
.home_greeting__rJykB {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 12px;
  min-height: 76px;
}
.home_greeting-title__giQqx {
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 725;
  line-height: 20px; /* 111.111% */
}
.home_greeting-desc__9hqIn {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

.home_logo__dqN1T {
  padding-top: 26px;
  /* padding-bottom: 30px; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.home_auth-btn__H1kaX {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  gap: 16px;
  width: 100%;
}
.home_auth-btn__H1kaX span {
  font-size: 16px !important;
}
.home_logout__dLmrE {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 12px;
  width: 100%;
}
.home_logout-phone__LR-SN {
}
.home_logout-change__UYlMJ {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}
.home_hero-row__0moub {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.home_content-row__LTON2 {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
}

@media screen and (min-width: 1200px) {
  .home_rule__cd9Jo {
    border-radius: 56px;
    border: 1px solid rgba(255, 255, 255, 0.24);
    background: rgba(255, 255, 255, 0.12);
    box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
      -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
      -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
      -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
      -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
    display: inline-flex;
    height: 48px;
    padding: 0px 8px 0px 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    color: #fff;
    text-align: right;
    /* font-family: "Yekan Bakh VF"; */
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px;
  }
  .home_greeting-title__giQqx {
    font-size: 20px;
  }
  .home_greeting-desc__9hqIn {
    font-size: 16px;
  }
  .home_information-title__y1eAu span {
    font-size: 14px;
  }
  .home_brands-title__J7p5r {
  }

  .home_inner__iVYU5 {
    flex-direction: row-reverse;
    max-width: 1000px;
    justify-content: space-between;
    width: 100%;
  }
  .home_home__1jket {
    min-height: 100vh;
    justify-content: space-between;
  }
  .home_hero-row__0moub {
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .home_content-row__LTON2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 400px;
  }
  .home_rule__cd9Jo {
    margin-bottom: unset;
    position: absolute;
    top: 43px;
    width: unset;
    right: 0;
  }
  .home_hero__9-mJf img {
    filter: drop-shadow(8px 9px 27px rgba(0, 0, 0, 0.08))
      drop-shadow(33px 35px 48px rgba(0, 0, 0, 0.07))
      drop-shadow(74px 80px 65px rgba(0, 0, 0, 0.04))
      drop-shadow(132px 142px 78px rgba(0, 0, 0, 0.01))
      drop-shadow(207px 221px 85px rgba(0, 0, 0, 0));
    width: 100%;
  }
  .home_rule-head__FaKYp {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    max-width: 1200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;AACA;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;AACb;AACA;AACA;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC;;;;4CAIwC;IACxC,oBAAoB;IACpB,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;EACA;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,QAAQ;EACV;EACA;IACE;;;;oDAIgD;IAChD,WAAW;EACb;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".home {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  min-height: calc(100vh - 60px);\n  min-height: calc(100dvh);\n}\n.inner {\n  max-width: 500px;\n  padding: 30px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.rule {\n  min-height: 32px;\n  margin-bottom: -56px;\n  z-index: 100;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n  width: 100%;\n}\n.ruleInner {\n}\n.hero {\n  margin-top: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 144px;\n}\n.hero img {\n  width: 100%;\n}\n.greeting {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  gap: 12px;\n  min-height: 76px;\n}\n.greeting-title {\n  color: #fff;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 725;\n  line-height: 20px; /* 111.111% */\n}\n.greeting-desc {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n}\n\n.logo {\n  padding-top: 26px;\n  /* padding-bottom: 30px; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.auth-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  gap: 16px;\n  width: 100%;\n}\n.auth-btn span {\n  font-size: 16px !important;\n}\n.logout {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #fff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  border-radius: 28px;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 8px 12px;\n  width: 100%;\n}\n.logout-phone {\n}\n.logout-change {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n.hero-row {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.content-row {\n  margin-top: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n}\n\n@media screen and (min-width: 1200px) {\n  .rule {\n    border-radius: 56px;\n    border: 1px solid rgba(255, 255, 255, 0.24);\n    background: rgba(255, 255, 255, 0.12);\n    box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n      -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n      -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n      -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n      -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n    display: inline-flex;\n    height: 48px;\n    padding: 0px 8px 0px 12px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    flex-shrink: 0;\n    color: #fff;\n    text-align: right;\n    /* font-family: \"Yekan Bakh VF\"; */\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 450;\n    line-height: 20px;\n  }\n  .greeting-title {\n    font-size: 20px;\n  }\n  .greeting-desc {\n    font-size: 16px;\n  }\n  .information-title span {\n    font-size: 14px;\n  }\n  .brands-title {\n  }\n\n  .inner {\n    flex-direction: row-reverse;\n    max-width: 1000px;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .home {\n    min-height: 100vh;\n    justify-content: space-between;\n  }\n  .hero-row {\n    max-width: 500px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  .content-row {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 400px;\n  }\n  .rule {\n    margin-bottom: unset;\n    position: absolute;\n    top: 43px;\n    width: unset;\n    right: 0;\n  }\n  .hero img {\n    filter: drop-shadow(8px 9px 27px rgba(0, 0, 0, 0.08))\n      drop-shadow(33px 35px 48px rgba(0, 0, 0, 0.07))\n      drop-shadow(74px 80px 65px rgba(0, 0, 0, 0.04))\n      drop-shadow(132px 142px 78px rgba(0, 0, 0, 0.01))\n      drop-shadow(207px 221px 85px rgba(0, 0, 0, 0));\n    width: 100%;\n  }\n  .rule-head {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    position: relative;\n    max-width: 1200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `home_home__1jket`,
	"inner": `home_inner__iVYU5`,
	"rule": `home_rule__cd9Jo`,
	"ruleInner": `home_ruleInner__RBuaG`,
	"hero": `home_hero__9-mJf`,
	"greeting": `home_greeting__rJykB`,
	"greeting-title": `home_greeting-title__giQqx`,
	"greeting-desc": `home_greeting-desc__9hqIn`,
	"logo": `home_logo__dqN1T`,
	"auth-btn": `home_auth-btn__H1kaX`,
	"logout": `home_logout__dLmrE`,
	"logout-phone": `home_logout-phone__LR-SN`,
	"logout-change": `home_logout-change__UYlMJ`,
	"hero-row": `home_hero-row__0moub`,
	"content-row": `home_content-row__LTON2`,
	"information-title": `home_information-title__y1eAu`,
	"brands-title": `home_brands-title__J7p5r`,
	"rule-head": `home_rule-head__FaKYp`
};
export default ___CSS_LOADER_EXPORT___;
